module.exports = " <div class=\"page-back-img page\" :style=\"{backgroundImage: 'url(' + backUrl + ') !important'}\"> <router-view transition=fade transition-mode=out-in></router-view> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 118
// module chunks = 14